import { BaseProductConstantS } from '../Constant/module/BaseProductConstantS.js';

export const notShowQtyEdit = (base_product_id) => {
  return BaseProductConstantS.PDF_BP_IDS.has(base_product_id);
};
